module.exports = __webpack_public_path__ + "img/img_promotion_pop_main_hello.b8100ab1.png";